import { useContext, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import Button from "components/ui/controls/button/button";
import { FaPlusCircle, FaEdit, FaTrashAlt, FaPiggyBank, FaBriefcase } from "react-icons/fa";
import Row from "components/ui/layout/row/row";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import ContratRetraitePageModal from "../situation professionnelle/modules/contrat retraite modal";
import { applyFormat } from "components/ui/ui-helpers";
import Dialogs from "components/ui/dialogs/dialogs";
import "components/app/settings/settings.css";
import InfoMessage from "components/ui/controls/info-message/info-message";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { EmptyStateMessage } from "../situation professionnelle/modules/ajout contrat facultatif modal";

const AjoutContratRetrPersoPageModalOptiRem = (props) => {
  const { ClientConjoint } = props;
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const [modalOpenConjoint, setmodalOpenConjoint] = useState(false);
  const annee = new Date().getFullYear();
  const StatutConjoint = context.state.PeriodeActuelle[0]?.StatutConjoint;
  const CorrespondanceContrat = {
    Madelin: "Madelin",
    Perp: "PERP",
    Per: "PER",
    Article62: "Assurance vie",
    Article83: "Article 83",
    Pero: "PER obligatoire",
    PEE: "PEE",
    PERCO: "PERECO",
  };

  const handleStatut = () => {
    let Statut = "TNS Article 62";

    if (props.ClientConjoint === "" && context.state.OptiRemPeriodeActuelle?.length > 0) {
      Statut = context.state.OptiRemPeriodeActuelle[0].Statut;
    }
    if (props.ClientConjoint === "Conjoint") {
      if (context.state.OptiRemPeriodeActuelleConjoint?.length > 0) {
        Statut = context.state.OptiRemPeriodeActuelleConjoint[0].Statut;
      } else {
        Statut = context.state.OptiRemPeriodeActuelle[0].StatutConjoint;
      }
    }
    return Statut;
  };
  // useEffect(() => {
  //   // if(modalOpen===true){
  //   //   console.log(context.state.Id)
  //   // context.handleResetContratRetraite();
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [modalOpen]);
  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              <div className="dossier-header">
                <div className="dossier-header-icon">
                  <FaBriefcase style={{ fontSize: "14px", color: "#6b7280" }} />
                </div>
                <h3 className="dossier-header-title">Contrats retraite de {context.state["Prenom" + ClientConjoint]}</h3>
              </div>
            </Row>
            <Row>
              <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
                <Button {...createStyledButton("primary")} onClick={() => setmodalOpen(true)}>
                  <FaPlusCircle style={{ marginRight: "8px" }} />
                  {context.state.TypeSimulation !== "Audit retraite" && `Ajouter un contrat de retraite existant pour ${context.state["Prenom" + ClientConjoint]}`}
                  {context.state.TypeSimulation === "Audit retraite" && `Ajouter un contrat de retraite pour ${context.state["Prenom" + ClientConjoint]}`}
                </Button>
              </Column>
            </Row>
            <ContratRetraitePageModal
              AccessRemExpress={props.AccessRemExpress}
              Statut={handleStatut()}
              Outil={props.Outil}
              visible={modalOpen}
              PayeurPrime="Perso"
              ClientConjoint={props.ClientConjoint}
              CliConj={props.ClientConjoint}
              onClose={() => {
                setmodalOpen(false);
              }}
            />
            <Row tpad>
              <div
                className="client-card-list"
                style={{
                  width: "100%",
                  minHeight: "0",
                  maxWidth: "100%",
                  margin: 0,
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: 8,
                }}
              >
                {/* Vérifier si aucun contrat n'est souscrit */}
                {context.state[props.Outil + "ListeContrat" + props.ClientConjoint].filter((Infos) => Infos.PayeurPrimeRetraite === "Perso").length === 0 && <EmptyStateMessage />}
                {context.state[props.Outil + "ListeContrat" + props.ClientConjoint].map(
                  (Infos, Index) =>
                    Infos.PayeurPrimeRetraite === "Perso" && (
                      <div key={"contrat-" + Infos.id} className="client-card" style={{ minHeight: 56, padding: "10px 12px" }}>
                        <div className="client-card-main">
                          <div className="client-card-info">
                            <div className="client-card-avatar" style={{ backgroundColor: "#e3f2fd" }}>
                              <FaPiggyBank style={{ color: "#3b82f6", fontSize: "16px" }} />
                            </div>
                            <div style={{ flex: 1 }}>
                              <div className="client-card-row">
                                <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.Compagnie : `Retraite - ${CorrespondanceContrat[Infos.Fiscalite]}`}</h4>
                              </div>
                              <div className="client-card-row">
                                <span
                                  style={{
                                    display: "inline-block",
                                    background: "#e3f2fd",
                                    color: "#2563eb",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    borderRadius: 12,
                                    padding: "2px 10px",
                                    margin: "2px 0",
                                  }}
                                >
                                  Épargne-retraite - {CorrespondanceContrat[Infos.Fiscalite]}
                                </span>
                              </div>
                              <div className="client-card-date">
                                {applyFormat(typeof Infos.Cotisation === "object" ? (annee in Infos.Cotisation ? Infos.Cotisation[annee].Versement : 0) : Infos.Cotisation, "uint", {
                                  thousands: " ",
                                  decimal: ",",
                                  unit: " € / an",
                                })}
                              </div>
                            </div>
                          </div>
                          <div className="client-card-actions" style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                            <Button
                              icon
                              {...createStyledButton("card-action", "cardEdit")}
                              onClick={() => {
                                context.handleModifyDeleteContratRetraite(Infos.id, "Modifier", props.Outil, props.ClientConjoint);
                                setmodalOpen(true);
                              }}
                            >
                              <FaEdit className="editContratFacPerso" id={"contratFac" + Infos.id} TypeContrat="Retraite" style={{ color: "#22c55e", fontSize: "12px" }} />
                            </Button>
                            <Button
                              icon
                              {...createStyledButton("card-action", "delete")}
                              onClick={() => {
                                Dialogs.confirm("Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?", "Suppression du contrat", () => {
                                  context.handleModifyDeleteContratRetraite(Infos.id, "Supprimer", props.Outil, props.ClientConjoint);
                                });
                              }}
                            >
                              <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                            </Button>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </Row>
          </Column>
        </CardBox>

        {context.state.InclureConjoint && StatutConjoint !== "Aucun" && (
          <CardBox>
            <Column fill>
              <Row>
                <div className="dossier-header">
                  <div className="dossier-header-icon">
                    <FaBriefcase style={{ fontSize: "14px", color: "#6b7280" }} />
                  </div>
                  <h3 className="dossier-header-title">Contrats retraite de {context.state["PrenomConjoint"]}</h3>
                </div>
              </Row>
              <Row>
                <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
                  <Button {...createStyledButton("primary")} onClick={() => setmodalOpenConjoint(true)}>
                    <FaPlusCircle style={{ marginRight: "8px" }} />
                    {context.state.TypeSimulation !== "Audit retraite" && `Ajouter un contrat de retraite existant pour ${context.state["PrenomConjoint"]}`}
                    {context.state.TypeSimulation === "Audit retraite" && `Ajouter un contrat de retraite pour ${context.state["PrenomConjoint"]}`}
                  </Button>
                </Column>
              </Row>
              <ContratRetraitePageModal
                AccessRemExpress={props.AccessRemExpress}
                Outil={props.Outil}
                Statut={context.state.OptiRemPeriodeActuelle[0]?.StatutConjoint}
                visible={modalOpenConjoint}
                PayeurPrime="Perso"
                ClientConjoint="Conjoint"
                CliConj="ConjointAssocie"
                onClose={() => {
                  setmodalOpenConjoint(false);
                }}
              />
                <Row tpad>
              <div
                className="client-card-list"
                style={{
                  width: "100%",
                  minHeight: "0",
                  maxWidth: "100%",
                  margin: 0,
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  gap: 8,
                }}
              >
                {/* Vérifier si aucun contrat n'est souscrit */}
                {context.state[props.Outil + "ListeContratConjoint"].filter((Infos) => Infos.PayeurPrimeRetraite === "Perso").length === 0 && <EmptyStateMessage />}
                {context.state[props.Outil + "ListeContratConjoint"].map(
                  (Infos, Index) =>
                    Infos.PayeurPrimeRetraite === "Perso" && (
                      <div key={"contrat-" + Infos.id} className="client-card" style={{ minHeight: 56, padding: "10px 12px" }}>
                        <div className="client-card-main">
                          <div className="client-card-info">
                            <div className="client-card-avatar" style={{ backgroundColor: "#e3f2fd" }}>
                              <FaPiggyBank style={{ color: "#3b82f6", fontSize: "16px" }} />
                            </div>
                            <div style={{ flex: 1 }}>
                              <div className="client-card-row">
                                <h4 className="client-card-title">{props.AccessRemExpress === false ? Infos.Compagnie : `Retraite - ${CorrespondanceContrat[Infos.Fiscalite]}`}</h4>
                              </div>
                              <div className="client-card-row">
                                <span
                                  style={{
                                    display: "inline-block",
                                    background: "#e3f2fd",
                                    color: "#2563eb",
                                    fontSize: 12,
                                    fontWeight: 500,
                                    borderRadius: 12,
                                    padding: "2px 10px",
                                    margin: "2px 0",
                                  }}
                                >
                                  Épargne-retraite - {CorrespondanceContrat[Infos.Fiscalite]}
                                </span>
                              </div>
                              <div className="client-card-date">
                                {applyFormat(typeof Infos.Cotisation === "object" ? (annee in Infos.Cotisation ? Infos.Cotisation[annee].Versement : 0) : Infos.Cotisation, "uint", {
                                  thousands: " ",
                                  decimal: ",",
                                  unit: " € / an",
                                })}
                              </div>
                            </div>
                          </div>
                          <div className="client-card-actions" style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                            <Button
                              icon
                              {...createStyledButton("card-action", "cardEdit")}
                              onClick={() => {
                                context.handleModifyDeleteContratRetraite(Infos.id, "Modifier", props.Outil, "Conjoint");
                                setmodalOpenConjoint(true);
                              }}
                            >
                              <FaEdit className="editContratFacPerso" id={"contratFac" + Infos.id} TypeContrat="Retraite" style={{ color: "#22c55e", fontSize: "12px" }} />
                            </Button>
                            <Button
                              icon
                              {...createStyledButton("card-action", "delete")}
                              onClick={() => {
                                Dialogs.confirm("Vous êtes sur le point de supprimer le contrat.\nVoulez-vous continuer ?", "Suppression du contrat", () => {
                                  context.handleModifyDeleteContratRetraite(Infos.id, "Supprimer", props.Outil, "Conjoint");
                                });
                              }}
                            >
                              <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                            </Button>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </Row>
            </Column>
          </CardBox>
        )}
      </Column>
    </>
  );
};

export default AjoutContratRetrPersoPageModalOptiRem;
